import { render, staticRenderFns } from "./gas-db.component.vue?vue&type=template&id=07b004cb"
import script from "./gas-db.component.ts?vue&type=script&lang=ts&external"
export * from "./gas-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b004cb')) {
      api.createRecord('07b004cb', component.options)
    } else {
      api.reload('07b004cb', component.options)
    }
    module.hot.accept("./gas-db.component.vue?vue&type=template&id=07b004cb", function () {
      api.rerender('07b004cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/gas-db/gas-db.component.vue"
export default component.exports